import React from 'react'
import PaginationFirstIcon from './../../assets/svgs/pagination_first.svg'
import PaginationPrevIcon from './../../assets/svgs/pagination_prev.svg'
import PaginationNextIcon from './../../assets/svgs/pagination_next.svg'
import PaginationLastIcon from './../../assets/svgs/pagination_last.svg'
import ButtonBase from '../ButtonBase'

import './paginationPanel.scss'

export default ({ pagination: { gotoPage: goToPage, pageCount, pageIndex, pageRows }, pageSize, columnCount, totalRows }) => {
  const first = pageIndex * pageSize + 1
  const last = first + pageRows.length - 1

  const handlePrev = () => goToPage(pageIndex - 1)
  const handleNext = () => goToPage(pageIndex + 1)

  const isFirstPage = pageIndex === 0
  const isLastPage = pageIndex === pageCount - 1

  return (
    <div className="Suc-pagination-panel" style={{ gridColumn: `1 / ${columnCount}` }}>
      <div
        className="Suc-pagination-title">{`${first === last ? first : `${first} - ${last}`} of ${totalRows}`}</div>
      <ButtonBase type={'button'} onClick={() => goToPage(0)} disabled={isFirstPage}
             className={`Suc-pagination-button Suc-prev ${isFirstPage ? 'disabled' : ''}`}>
        <PaginationFirstIcon/>
      </ButtonBase>
      <ButtonBase type={'button'} onClick={handlePrev} disabled={isFirstPage}
             className={`Suc-pagination-button ${isFirstPage ? 'disabled' : ''}`}>
        <PaginationPrevIcon/>
      </ButtonBase>
      <div className={'Suc-current-page'}>
        {pageIndex + 1}
      </div>
      <ButtonBase type={'button'} onClick={handleNext} disabled={isLastPage}
             className={`Suc-pagination-button ${isFirstPage ? 'disabled' : ''}`}>
        <PaginationNextIcon/>
      </ButtonBase>
      <ButtonBase type={'button'} onClick={() => goToPage(pageCount - 1)} disabled={isLastPage}
             className={`Suc-pagination-button Suc-next ${isFirstPage ? 'disabled' : ''}`}>
        <PaginationLastIcon/>
      </ButtonBase>
    </div>
  )
}
